import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ProfileState } from '../types/profile';

const initialState = {
  hormoneType: 'testosterone' as const,
  hasSelectedProfile: false,
  isNerdMode: false,
  isTrainerMode: false,
  lastUpdate: Date.now()
};

export const useProfileStore = create<ProfileState>()(
  persist(
    (set) => ({
      ...initialState,
      setHormoneType: (type) => set({ 
        hormoneType: type,
        lastUpdate: Date.now() 
      }),
      setHasSelectedProfile: (value) => set({ 
        hasSelectedProfile: value,
        lastUpdate: Date.now() 
      }),
      toggleNerdMode: () => set((state) => ({ 
        isNerdMode: !state.isNerdMode,
        lastUpdate: Date.now()
      })),
      toggleTrainerMode: () => set((state) => ({ 
        isTrainerMode: !state.isTrainerMode,
        lastUpdate: Date.now()
      })),
      resetProfile: () => set({ ...initialState, lastUpdate: Date.now() })
    }),
    {
      name: 'profile-storage',
      version: 6,
      migrate: (persistedState: any, version: number) => {
        if (version < 6) {
          return {
            ...initialState,
            ...persistedState,
            lastUpdate: Date.now()
          };
        }
        return persistedState as ProfileState;
      }
    }
  )
);